export enum DocumentType {
  PASSPORT = 'PASSPORT',
  C_CIUDADANIA = 'C_CIUDADANIA',
  C_EXTRANJERIA = 'C_EXTRANJERIA',
  PEP = 'PEP',
  DNI = 'DNI',
  NIT = 'NIT'
}
